exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "* {\n  margin: 0px;\n  padding: 0px; }\n\n:host {\n  padding: 10px 10px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-height: calc(100vh - 20px); }\n\n.tabs__tab-bar {\n  align-self: center;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: -12px;\n  z-index: 1000;\n  border: 1px solid #c9c9c9; }\n\n.tabs__tab {\n  padding: 4px 10px;\n  display: inline-block;\n  background-color: white;\n  cursor: pointer; }\n\n.tabs__tab.active {\n  background-color: #6fbbff !important;\n  color: white; }\n\n.overlay {\n  background: #e0e0e0;\n  opacity: 0.5;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/tabs-container/tabs.container.scss
// module id = 11
// module chunks = 0 1